/** TestingStatus
 * generated by enums.tst
**/
var TestingStatus;
(function (TestingStatus) {
    TestingStatus[TestingStatus["STARTED"] = 0] = "STARTED";
    TestingStatus[TestingStatus["RUNNING"] = 1] = "RUNNING";
    TestingStatus[TestingStatus["COMPLETED"] = 2] = "COMPLETED";
    TestingStatus[TestingStatus["STOPPED"] = 3] = "STOPPED";
    TestingStatus[TestingStatus["CANCELLED"] = 4] = "CANCELLED";
})(TestingStatus || (TestingStatus = {}));
